import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';

export default class MenuPopup extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);

    const { gameConfig } = ABCyaLib.Environment.instance;
    const popupbg = ABCyaPhaser.Images.addImage(0, 0, 'menu-bg', this).setOrigin(0);
    this.popupWidth = popupbg.getBounds().width;
    this.popupHeight = popupbg.getBounds().height;

    const printBtn = this.scene.add.container();
    this.add(printBtn);
    const printBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._menu_btn_base, printBtn).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(printBtn);

    const printBtnTxt = ABCyaPhaser.Text.addText(printBtnBg.width / 2, printBtnBg.height / 2 - 2, gameConfig.menuPopupFontSize, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('print_button'), printBtn, true).setOrigin(0.5);
    ABCyaPhaser.Buttons.convertToButton(printBtn, { onClick: () => this.handleBtnPress(printBtn) });
    printBtn.btnId = 'print';

    const saveBtn = this.scene.add.container();
    this.add(saveBtn);
    const saveBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._menu_btn_base, saveBtn).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(saveBtn);

    const saveBtnTxt = ABCyaPhaser.Text.addText(saveBtnBg.width / 2, saveBtnBg.height / 2 - 2, gameConfig.menuPopupFontSize, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('save_button'), saveBtn, true).setOrigin(0.5);
    ABCyaPhaser.Buttons.convertToButton(saveBtn, { onClick: () => this.handleBtnPress(saveBtn) });
    saveBtn.btnId = 'save';

    const newBtn = this.scene.add.container();
    this.add(newBtn);
    const newBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._menu_btn_base, newBtn).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(newBtn);

    const newBtnTxt = ABCyaPhaser.Text.addText(newBtnBg.width / 2, newBtnBg.height / 2 - 2, gameConfig.menuPopupFontSize, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('new_button'), newBtn, true).setOrigin(0.5);
    ABCyaPhaser.Buttons.convertToButton(newBtn, { onClick: () => this.handleBtnPress(newBtn) });
    newBtn.btnId = 'new';

    const cancelBtn = this.scene.add.container();
    this.add(cancelBtn);
    const cancelBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._menu_btn_base, cancelBtn).setOrigin(0);
    ABCyaPhaser.Container.setContainerInteractive(cancelBtn);

    const cancelBtnTxt = ABCyaPhaser.Text.addText(cancelBtnBg.width / 2, cancelBtnBg.height / 2 - 2, gameConfig.menuPopupFontSize, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('cancel_button'), cancelBtn, true).setOrigin(0.5);
    ABCyaPhaser.Buttons.convertToButton(cancelBtn, { onClick: () => this.handleBtnPress(cancelBtn) });
    cancelBtn.btnId = 'cancel';

    this.btns = [printBtn, saveBtn, newBtn, cancelBtn];

    const spacing = (this.popupWidth - (this.btns[0].getBounds().width * this.btns.length)) / (this.btns.length + 1);
    let i = 0;
    while (i < this.btns.length) {
      this.btns[i].x = spacing + ((this.btns[i].getBounds().width + spacing) * i);
      this.btns[i].y = (this.popupHeight / 2) - (this.btns[i].getBounds().height / 2);
      i++;
    }
  }

  handleBtnPress(btn) {
    this.toggleBtns(false);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pixel_art_select_sound, this.scene);

    this.emit('MENU_CLICK', btn);
  };

  toggleBtns(toggle) {
    this.btns.forEach((btn) => { btn.setEnabled(toggle); });
  }
}